export default __webpack_public_path__ + "static/differenttips-2ff5eea9de31e1f63afc42d7d9a9c7fb.png";